module.exports = __webpack_public_path__ + "img/interactive-fountain_1.76600ab7.jpg";